import { type RouteObject } from 'react-router';

import { Layout } from '#/layouts/Layout/Layout';
import * as userInviteHorizonRouteExports from '#/modules/auth/pages/userInvite/AuthUserInvite.horizon-route';
import { authRouteObjects } from '#/modules/auth/routing/auth.route-objects';
import { authUserInviteRoute } from '#/modules/auth/routing/auth.routes';
import { cmsRouteObjects } from '#/modules/cms/routing/cms.route-objects';
import { embedSearchWidgetRouteObjects } from '#/modules/embedSearchWidget/routing/embedSearchWidget.route-objects';
import * as importedEventHorizonRouteExports from '#/modules/listing/events/pages/imported/ImportedEvent.horizon-route';
import { listingRouteObjects } from '#/modules/listing/routing/listing.route-objects';
import { importedEventRoute } from '#/modules/listing/routing/listing.routes';
import * as viewDonationReceiptHorizonRouteExports from '#/modules/orgDashboard/pages/invoices/publicView/ViewDonationReceipt.horizon-route';
import * as viewInvoiceHorizonRouteExports from '#/modules/orgDashboard/pages/invoices/publicView/ViewInvoice.horizon-route';
import * as orgDashboardRateRecommendedCandidateHorizonRouteExports from '#/modules/orgDashboard/pages/recommendedCandidates/rate/OrgDashboardRateRecommendedCandidate.horizon-route';
import { orgDashboardRouteObjects } from '#/modules/orgDashboard/routing/orgDashboard.route-objects';
import { salariesRouteObjects } from '#/modules/salaries/routing/salaries.route-objects';
import { searchRouteObjects } from '#/modules/search/routing/search.route-objects';
import * as orgDashboardCreateOrgHorizonRouteExports from '#/modules/userDashboard/pages/CreateOrg/OrgDashboardCreateOrg.horizon-route';
import { userDashboardRouteObjects } from '#/modules/userDashboard/routing/userDashboard.route-objects';
import { userProfileRouteObjects } from '#/modules/userProfile/routing/userProfile.route-objects';
import * as invalidLinkHorizonRouteExports from '#/pages/InvalidLink/InvalidLink.horizon-route';
import * as unsubscribeHorizonRouteExports from '#/pages/Unsubscribe/Unsubscribe.horizon-route';
import * as viewUserUploadHorizonRouteExports from '#/pages/ViewUserUpload/ViewUserUpload.horizon-route';

import {
  createOrgRoute,
  emailRateRecommendedCandidateRoute,
  invalidOrExpiredLinkRoute,
  unsubscribeOrgPreferenceRoute,
  unsubscribePreferenceRoute,
  userUploadsRouteGroup,
  viewDonationReceiptRoute,
  viewInvoiceRoute,
} from './routes';
import { horizonRouteToObject } from './utils/horizonRouteToObject';

export function getRouteObjects(): RouteObject[] {
  return [
    {
      Component: Layout,
      children: [
        ...[
          unsubscribePreferenceRoute.fullPath,
          unsubscribeOrgPreferenceRoute.fullPath,
        ].map((path) => ({
          path,
          ...horizonRouteToObject(unsubscribeHorizonRouteExports),
        })),
        {
          path: invalidOrExpiredLinkRoute.fullPath,
          ...horizonRouteToObject(invalidLinkHorizonRouteExports),
        },
        {
          path: viewInvoiceRoute.fullPath,
          ...horizonRouteToObject(viewInvoiceHorizonRouteExports),
        },
        {
          path: viewDonationReceiptRoute.fullPath,
          ...horizonRouteToObject(viewDonationReceiptHorizonRouteExports),
        },
        {
          path: userUploadsRouteGroup.fullWrapperPath,
          ...horizonRouteToObject(viewUserUploadHorizonRouteExports),
        },
        {
          path: importedEventRoute.fullPath,
          ...horizonRouteToObject(importedEventHorizonRouteExports),
        },

        {
          path: authUserInviteRoute.fullPath,
          ...horizonRouteToObject(userInviteHorizonRouteExports),
        },
        {
          path: createOrgRoute.fullPath,
          ...horizonRouteToObject(orgDashboardCreateOrgHorizonRouteExports),
        },
        {
          path: emailRateRecommendedCandidateRoute.fullPath,
          ...horizonRouteToObject(
            orgDashboardRateRecommendedCandidateHorizonRouteExports,
          ),
        },
        ...authRouteObjects,
        ...cmsRouteObjects,
        ...listingRouteObjects,
        ...searchRouteObjects,
        ...salariesRouteObjects,
        ...userDashboardRouteObjects,
        ...userProfileRouteObjects,
        ...orgDashboardRouteObjects,
      ],
    },

    ...embedSearchWidgetRouteObjects,

    ...['/cms/*', '/staff/*'].map(
      (staffPath) =>
        ({
          path: staffPath,
          Component: () => {
            // Reload the page, going from main to the staff app
            window.location.reload();
            return null;
          },
        }) satisfies RouteObject,
    ),
  ] satisfies RouteObject[];
}
